import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchPatients } from "./actions";
import { Patient } from "../../interfaces/api/patients";

interface PatientsState {
  data: Patient[];
  loading: boolean;
  error: string | null;
  total: number;
  page: number;
  pageSize: number;
}

const getInitialState = (): PatientsState => ({
  data: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  pageSize: 0,
});

const patientsSlice = createSlice({
  name: "patients",
  initialState: getInitialState(),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPatients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchPatients.fulfilled,
        (
          state,
          action: PayloadAction<{
            data: Patient[];
            total: number;
            page: number;
            pageSize: number;
          }>,
        ) => {
          state.loading = false;
          state.data = action.payload.data;
          state.total = action.payload.total;
          state.page = action.payload.page;
          state.pageSize = action.payload.pageSize;
        },
      )
      .addCase(fetchPatients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch patients";
      });
  },
});

export default patientsSlice.reducer;
